import { router } from '@inertiajs/react'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { organizationAnalyticsPath, organizationDashboardPath } from '@/routes'

type DashboardTabsProps = {
  organizationId: string
  active: 'overview' | 'analytics'
  analyticsEnabled?: boolean
}

export function DashboardTabs({ organizationId, active, analyticsEnabled = true }: DashboardTabsProps) {
  if (!analyticsEnabled) return null

  return (
    <Tabs
      value={active}
      onValueChange={(value) => {
        if (value === 'analytics') {
          router.visit(organizationAnalyticsPath(organizationId), { preserveScroll: true })
        } else {
          router.visit(organizationDashboardPath(organizationId), { preserveScroll: true })
        }
      }}
      className="w-full"
    >
      <div className="mb-6 flex w-full justify-center">
        <TabsList className="grid h-auto min-h-11 w-full max-w-2xl grid-cols-2 p-1 shadow-md md:w-[400px]">
          <TabsTrigger
            value="overview"
            className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground min-h-11 cursor-pointer"
          >
            Overview
          </TabsTrigger>
          <TabsTrigger
            value="analytics"
            className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground min-h-11 cursor-pointer"
          >
            Analytics
          </TabsTrigger>
        </TabsList>
      </div>
    </Tabs>
  )
}
